import { apiRequest } from '@common/api/utils';

export const COUNTRY_CODE_SELECT_CONFIG = {
  searchable: true,
  isAsync: true,
  hideHint: false,
  hideHintOnInit: true,
  showOnlyInputOnFocus: true,
  optionMarkup: `
    <div class="sr-select__option" role="option" data-value="{{value}}">
      <div class="phone-input__option">
        <div class="phone-input__flag">
          <span class="iti__flag iti__{{label}}"> </span>
        </div>
        <div class="phone-input__option-code">
          {{value}}
        </div>
      </div>
    </div>
  `,
  loadOptions: async keyword => {
    try {
      const json = await apiRequest(
        'GET',
        '/country-codes',
        null,
        // Expect a '+' in the input
        { params: { q: encodeURIComponent(keyword) } },
      );
      return json.data.map(
        ({ flag, dial_code: dialCode }) => (
          { label: flag, value: dialCode }
        ),
      );
    } catch (e) {
      return [];
    }
  },
};

export const UNIVERSITY_SELECT_CONFIG = {
  isAsync: true,
  isCreatable: true,
  loadOptions: async (keyword) => {
    const json = await apiRequest(
      'GET',
      '/get-universities',
      null,
      { params: { q: keyword } },
    );
    return json.items.map(item => ({ label: item.text, value: item.id }));
  },
};

export const ORGNAME_SELECT_CONFIG = {
  isAsync: true,
  isCreatable: true,
  loadOptions: async (keyword) => {
    const json = await apiRequest(
      'GET',
      '/get-companies',
      null,
      { params: { q: keyword } },
    );
    return json.items.map(item => ({ label: item.text, value: item.id }));
  },
};
